import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../config/firebase";

const EMAILS_COLLECTION = collection(db, "omnicare_emails");

/**
 * Save a user's email along with anonymized survey metadata.
 * Does NOT store individual quiz answers — just high-level context.
 */
export async function saveEmail(email, metadata = {}) {
  if (!email || !email.includes("@")) return null;

  try {
    const doc = await addDoc(EMAILS_COLLECTION, {
      email: email.trim().toLowerCase(),
      subscribedAt: serverTimestamp(),
      source: metadata.source || "quiz",
      locale: metadata.locale || "en",
      // Anonymous metadata (no PII beyond email)
      ageRange: metadata.ageRange || null,       // e.g. "40-49" not exact age
      sex: metadata.sex || null,
      location: metadata.location || null,
      screeningsRecommended: metadata.screeningsCount || null,
      unsubscribed: false,
    });
    return doc.id;
  } catch (err) {
    console.warn("Email save failed:", err);
    return null;
  }
}
